import { render, staticRenderFns } from "./JVxeImageCell.vue?vue&type=template&id=c5483c02&scoped=true&"
import script from "./JVxeImageCell.vue?vue&type=script&lang=js&"
export * from "./JVxeImageCell.vue?vue&type=script&lang=js&"
import style0 from "./JVxeImageCell.vue?vue&type=style&index=0&id=c5483c02&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5483c02",
  null
  
)

export default component.exports